export enum QueryParameters {
  POSITION_KEY = 'positionkey',
  AIRPORT_CODE = 'AirportCode',
  WEBSOCKET_BRIDGE_PORT = 'ConcentratorBridgePort',
  BGR_SESSION_NAME = 'BGRSessionName',
  BAG_TAG_PRINTER = 'BagTagPrinter',
  BOARDING_PASS_PRINTER = 'BoardingPassPrinter',
  STATION_NUMERIC = 'StationNumeric',
}
